import _toConsumableArray from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useRef, useState } from 'react';
import { reducerStateMap } from './constants';
import { changeToPacificTimezone, PACIFIC_TIMEZONE } from './utils';
import { DateTime } from 'luxon';
import { getBrowserName } from '../../../utils/utilityFunction';
import { BROWSER } from '../../../constants/globalConstants';
var ScheduleDialog = function ScheduleDialog(_ref) {
  var action = _ref.action,
    stateClasses = _ref.stateClasses,
    isOpen = _ref.isOpen,
    setIsOpen = _ref.setIsOpen,
    runDeployAction = _ref.runDeployAction,
    setScheduled = _ref.setScheduled;
  var datetimeRef = useRef(null);
  var _useState = useState(''),
    errorMessage = _useState[0],
    setErrorMessage = _useState[1];
  var onScheduleSuccess = function onScheduleSuccess(_ref2) {
    var payload = _ref2.payload,
      data = _ref2.data;
    if (setScheduled) {
      setScheduled(function (prev) {
        var _data$result;
        return [].concat(_toConsumableArray(prev), [{
          Id: data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.Id,
          TriggeredAt: payload.triggeredAt
        }]);
      });
    }
    setIsOpen(false);
  };
  var handleSchedule = function handleSchedule(date, setErrorMessage) {
    if (!date) {
      return setErrorMessage('Date is missing');
    }
    var selectedDate = new Date(date);
    if (isNaN(selectedDate)) {
      return setErrorMessage('Date is invalid');
    }
    var currentDate = new Date();
    if (selectedDate.toISOString() < currentDate.toISOString()) {
      return setErrorMessage('Date or time must be greater');
    }
    setErrorMessage('');
    runDeployAction(action, selectedDate, onScheduleSuccess);
  };
  return __jsx("dialog", {
    open: isOpen
  }, __jsx("div", null, __jsx("input", {
    ref: datetimeRef,
    className: "nva-instant-preview__deploy-datetime",
    type: "datetime-local",
    min: changeToPacificTimezone(new Date()).toISOString().slice(0, 16)
  })), errorMessage && __jsx("p", {
    clasName: "nva-instant-preview__deploy-status is-error"
  }, errorMessage), __jsx("div", null, __jsx("button", {
    className: "nva-instant-preview__button nva-instant-preview__button--text",
    type: "button",
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }, "Close"), __jsx("button", {
    className: "nva-instant-preview__button nva-instant-preview__button--dark ".concat(stateClasses[reducerStateMap[action]]),
    type: "button",
    onClick: function onClick() {
      return handleSchedule(DateTime.fromISO(datetimeRef.current.value, {
        zone: PACIFIC_TIMEZONE
      }).toString(), setErrorMessage, setIsOpen);
    }
  }, "Schedule")));
};
export default ScheduleDialog;